import HttpService from './httpService';
import config from '../../config';

class MatriculacionApiService extends HttpService {
  constructor(baseUrl, generalCatch) {
    super(baseUrl, generalCatch);
  }

  async getMatriculaById(id, { headquarter }) {
    return this.get(`matriculas/${id}`, { params: { headquarter } });
  }

  async cargarFidelizacion({ empresaId, procedence }) {
    return this.get('cargarFidelizacion', { params: { empresaId, procedence } });
  }

  async consultarBalanceGeneral({ headquarter, id }) {
    return this.get('consultarBalanceGeneral', { params: { headquarter, id } });
  }

  async consultarBalance({ headquarter, id }) {
    return this.get('consultarBalance', { params: { headquarter, id } });
  }

  async buscarGrupos({ headquarter, edit }) {
    return this.get('buscarGrupos', { params: { headquarter, edit } });
  }

  async cursosAprobados({ headquarter, id }) {
    return this.get('cursosAprobados', { params: { headquarter, id } });
  }

  async mostrarRecibos({ headquarter, id }) {
    return this.get('mostrarRecibos', { params: { headquarter, id } });
  }

  async buscarTipos({ headquarter, codigoGrupo, studentId }) {
    return this.get('buscarTipos', { params: { headquarter, codigoGrupo, studentId } });
  }

  async buscarModulos({ groupId, headquarter, studentId, enrollmentId }) {
    return this.get('buscarModulos', { params: { groupId, headquarter, studentId, enrollmentId } });
  }

  async obtenerTotal({ headquarter, id }) {
    return this.get('obtenerTotal', { params: { headquarter, id } });
  }

  async detalleMatricula({ headquarter, id }) {
    return this.get('detalleMatricula', { params: { headquarter, id } });
  }

  async buscarPreciosCiclo({ headquarter, groupId, id }) {
    return this.get('buscarPreciosCiclo', { params: { headquarter, groupId, id } });
  }

  async guardarMatricula(data, { headquarter, groupId, id }) {
    return this.post('guardarMatricula', data, { params: { headquarter, groupId, id } });
  }

  async agregarComentario(data) {
    return this.post('agregarComentario', data);
  }

  async actualizarModulos(data) {
    return this.post('actualizarModulos', data);
  }

  async obtenerConvocatorias({ headquarter, idMatricula, idActividad }) {
    return this.get('obtenerConvocatorias', { params: { headquarter, idMatricula, idActividad } });
  }

  // Notas de RA (matriculas del curriculum nuevo LOE). Mismos parametros que
  // obtenerConvocatorias: idMatricula = NumMatricula, idActividad = codigocurso
  // del modulo. Devuelve { notas: [...], catalogoRAs: [...] }. catalogoRAs viene
  // poblado aunque no haya notas; si llega vacio, el modulo no es del curriculum
  // nuevo y la UI de RA no se muestra.
  async obtenerNotasRA({ headquarter, idMatricula, idActividad }) {
    return this.get('obtenerNotasRA', { params: { headquarter, idMatricula, idActividad } });
  }

  // Upsert de una nota de RA. `idmatriculal` es matriculal.id (la linea de
  // matricula), NO el NumMatricula. notaRA entero 1-10 o estado interno negativo;
  // conv 1 (ordinaria) o 2 (extraordinaria). silent: el modal muestra el mensaje
  // de error del backend en vez del toast global.
  async crearNotaRA({ headquarter, idmatriculal, CodiRA, notaRA, conv }) {
    return this.post(
      'crearNotaRA',
      { headquarter, idmatriculal, CodiRA, notaRA, conv },
      { silent: true },
    );
  }

  // Elimina una nota de RA por su ID (el campo ID que devuelve obtenerNotasRA).
  // Idempotente: deleted: 0 si ya no existia, se trata como exito.
  async eliminarNotaRA({ headquarter, id }) {
    return this.post('eliminarNotaRA', { headquarter, id }, { silent: true });
  }

  async guardarEstadosActividad(data, { headquarter }) {
    return this.put('guardarEstadosActividad', data, { params: { headquarter } });
  }

  async cargarEstadosActividad({ headquarter }) {
    return this.get('cargarEstadosActividad', { params: { headquarter } });
  }

  async cargarListaConvocatorias({ headquarter }) {
    return this.get('cargarListaConvocatorias', { params: { headquarter } });
  }

  async obtenerMotivoBaja({ headquarter }) {
    return this.get('obtenerMotivoBaja', { params: { headquarter } });
  }

  async cargarEstadosRecibo({ headquarter }) {
    return this.get('cargarEstadosRecibo', { params: { headquarter } });
  }

  async buscarCiclos({ headquarter }) {
    return this.get('buscarCiclos', { params: { headquarter } });
  }

  async buscarCentros({ headquarter }) {
    return this.get('buscarCentros', { params: { headquarter } });
  }

  async buscarEstados({ headquarter }) {
    return this.get('buscarEstados', { params: { headquarter } });
  }

  async filtrarSolicitudes(params) {
    return this.get('filtrarSolicitudes', {
      params,
      responseType: params.descarga ? 'blob' : 'json',
    });
  }

  async mostrarCambios({ headquarter, id }) {
    return this.get('mostrarCambios', { params: { headquarter, id } });
  }

  async obtenerHistorial({ entidad, entidadId, headquarter, limit = 50, offset = 0 }) {
    return this.get('historial', {
      params: { entidad, entidadId, headquarter, limit, offset },
    });
  }

  async estaCursando({ headquarter, id }) {
    return this.get('estaCursando', { params: { headquarter, id } });
  }

  async cargarMetodosPago({ headquarter }) {
    return this.get('cargarMetodosPago', { params: { headquarter } });
  }

  async cargarListaTipoCliente({ headquarter }) {
    return this.get('cargarListaTipoCliente', { params: { headquarter } });
  }

  async peticionActiva({ headquarter, id }) {
    return this.get('peticionActiva', { params: { headquarter, id } });
  }

  async crearConvocatoria(data, { headquarter }) {
    return this.post('crearConvocatoria', data, { params: { headquarter } });
  }

  async agregarAsignatura(data) {
    return this.post('agregarAsignatura', data);
  }

  async bajaMatricula(data) {
    return this.post('bajaMatricula', data);
  }

  async addRecibo({ headquarter, recibos = [], numMatricula }) {
    return this.post('addRecibo', { headquarter, recibos, numMatricula });
  }

  async editRecibo({ headquarter, recibo, data }) {
    return this.post('editRecibo', { headquarter, recibo, data });
  }

  async deleteRecibo({ headquarter, idRecibos }) {
    return this.post('deleteRecibo', { headquarter, idRecibos });
  }

  async reenviarPagoInicial(data) {
    return this.post('reenviarPagoInicial', data);
  }

  async reenviarEmailMetodoPago(data) {
    return this.post('reenviarEmailMetodoPago', data);
  }

  async enviarEmailPagoRedsys(data) {
    return this.post('enviarEmailPagoRedsys', data);
  }

  async enviarCambioTarjetaRedsys(data) {
    return this.post('redsys/enviar-cambio-tarjeta', data);
  }

  async cobrarReciboManual(data, options = {}) {
    return this.post('cobrarReciboManual', data, options);
  }

  async cobrarReciboManualRedsys(data, options = {}) {
    return this.post('redsys/cobrar-recibo-manual', data, options);
  }
}

const matriculacionApiService = new MatriculacionApiService(config.REACT_APP_NODE_API);
export default matriculacionApiService;
